export function fitToGeoDkLayerExtent (map, layer) {
  const extent = layer.getSource().getExtent();

  // #56: Udvendig buffer på 3 x højde/bredde, dog minst 100m og højest 400m.
  let bufferX = (extent[2] - extent[0]) * (3 / 2);
  if (bufferX < 50) {
    bufferX = 50;
  } else if (bufferX > 200) {
    bufferX = 200;
  }

  let bufferY = (extent[3] - extent[1]) * (3 / 2);
  if (bufferY < 50) {
    bufferY = 50;
  } else if (bufferY > 200) {
    bufferY = 200;
  }

  const extentWithBuffer = [
    extent[0] - bufferX,
    extent[1] - bufferY,
    extent[2] + bufferX,
    extent[3] + bufferY,
  ];
  map.getView().fit(extentWithBuffer, {
    size: map.getSize(),
  });
};

export function isLayerVisible (map, layerName) {
  return map.getLayers().getArray().find(function (l) {
    return l.get('title') === layerName;
  }).get('visible');
}
